import axios from "axios"
export default {
    namespaced: true,
    state: {
        token: null,
        user: null,
        auth_error: null,
        access_token: null,
    },
    getters: {
        //return auth state
        authenticated(state) {
            return state.token && state.user
        },
        //return user object to be used in dashboard
        user(state) {
            return state.user
        },
        //log authentication error
        authenticationError(state) {
            return state.auth_error
        },
        //user profile picture
        user_profile_picture(state) {
            return state.user.profile_picture_url
        },

        // return user permission state for otp screen access
        otp_permission(state) {
            return state.access_token || localStorage.getItem("access_token")
        }
    },
    mutations: {
        SET_TOKEN(state, payload) {
            state.token = payload
        },
        SET_USER(state, payload) {
            state.user = payload
        },
        SET_AUTH_ERROR(state, error) {
            state.auth_error = error
        },
        SET_OTP_SCREEN_PERMISSION(state, payload) {
            state.access_token = payload
        }
    },
    actions: {
        async login({ dispatch }, credentials) {
            try {
                const {data:response} = await axios.post("/auth/login", credentials);
                
                //if error is encountered while logging in the user
                if (!response.success) {
                    dispatch("authenticationError", response.message)
                    return
                }
                //if no error add the token to the header and proceed with the next request
                return dispatch("attempt", response.data.bearerToken)
            }
            catch (error) {
                dispatch("authenticationError", error.response.data.message)
                return
            }
        },

        //set authentication error in global store
        authenticationError({ commit }, error) {
            commit("SET_AUTH_ERROR", error)
        },

        //set token in global store
        set_otp_access_token({ commit }, token) {
            //persist the token to local storage
            localStorage.setItem("access_token", token)
            commit("SET_OTP_SCREEN_PERMISSION", token)
        },


        //try to get user profile using token provided from login
        async attempt({ commit, state }, token) {
            //only commit the token if there is any
            if (token) {
                commit("SET_TOKEN", token)
            }
            //if there is no token in the state, don not make request to get user profile
            if (!state.token) {
                return
            }
            try {
                //make request to user profile
                const response = await axios.get("/auth/me");
                const { data } = response.data;
                commit("SET_USER", data.user)
            } catch (error) {
                commit("SET_TOKEN", null)
                commit("SET_USER", null)
            }
        }, logout({ commit }) {
            localStorage.removeItem("token")
            commit("SET_TOKEN", null)
            commit("SET_USER", null)
        }
    },
}

